import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Util from '../../../../../misc/util';
import { CardApprovalRequest } from '../../../../../queries/pxtraCard';
import { EXPIRY_WARNING_DAYS, daysUntil } from '../utils';

export const ExpiryCell: FC<{ request: CardApprovalRequest }> = ({ request }) => {
  const { t } = useTranslation();

  if (request.status !== 'open') {
    return (
      <Typography variant="body2" color="grey.500">
        –
      </Typography>
    );
  }

  const days = daysUntil(request.expires_on);

  if (days === null || !request.expires_on) {
    return (
      <Typography variant="body2" color="grey.500">
        –
      </Typography>
    );
  }

  return (
    <Box className="flex flex-col whitespace-nowrap">
      <Typography variant="body2" className="leading-4">
        {Util.formatDate(request.expires_on)}
      </Typography>
      <Typography
        className="leading-4"
        variant="caption"
        color={days <= EXPIRY_WARNING_DAYS ? 'error.main' : 'grey.500'}
      >
        {days <= 0 ? t('pxtraCard:expiresToday') : t('pxtraCard:expiresIn', { count: days })}
      </Typography>
    </Box>
  );
};
